import { render, staticRenderFns } from "./SignInSignUpContent.vue?vue&type=template&id=1d81bad0&scoped=true"
import script from "./SignInSignUpContent.vue?vue&type=script&lang=js"
export * from "./SignInSignUpContent.vue?vue&type=script&lang=js"
import style0 from "./SignInSignUpContent.vue?vue&type=style&index=0&id=1d81bad0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d81bad0",
  null
  
)

export default component.exports